import { Send } from "lucide-react";
import { useState, FormEvent } from "react";

interface TextInputProps {
  onSubmit: (text: string) => void;
  placeholder?: string;
  showClose?: boolean;
  onClose?: () => void;
}

const TextInput = ({
  onSubmit,
  placeholder = "Type your message...",
  showClose = false,
  onClose,
}: TextInputProps) => {
  const [value, setValue] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (value.trim()) {
      onSubmit(value.trim());
      setValue("");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full relative">
      {showClose && onClose && (
        <button
          type="button"
          onClick={onClose}
          className="absolute -top-2 -right-2 z-10 w-8 h-8 rounded-full bg-muted border border-border flex items-center justify-center text-muted-foreground hover:bg-muted/80 hover:text-foreground transition-colors"
          aria-label="Đóng"
          title="Đóng"
        >
          ×
        </button>
      )}
      <div className="glass-panel p-2 flex items-center gap-2">
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          className="flex-1 bg-transparent border-none outline-none px-4 py-3 text-foreground placeholder:text-muted-foreground text-sm sm:text-base input-glow rounded-xl"
        />
        <button
          type="submit"
          disabled={!value.trim()}
          className="w-12 h-12 rounded-xl bg-primary/20 hover:bg-primary/30 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center transition-all duration-200 hover:scale-105 active:scale-95"
          aria-label="Send message"
        >
          <Send className="w-5 h-5 text-primary" />
        </button>
      </div>
    </form>
  );
};

export default TextInput;
